export default "__VITE_ASSET__b368299c__"